import { GAMIFICATION, SYSTEM, WALLET } from 'socket-resources/namespaces/index'

export const WALLET_USER_WALLET_BALANCE = `${WALLET}/userWalletBalance`
export const SYSTEM_GAME_SETTINGS_UPDATE = `${SYSTEM}/gameSettings`
export const GAMIFICATION_DATA = `${GAMIFICATION}/data`